import { render, staticRenderFns } from "./goodsStat.vue?vue&type=template&id=5eb7a7e1&"
import script from "./goodsStat.vue?vue&type=script&lang=js&"
export * from "./goodsStat.vue?vue&type=script&lang=js&"
import style0 from "./goodsStat.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports